export const reload_page = "RELOAD_PAGE";